import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const StartFlex = styled(Flex).withConfig({ displayName: 'ContentPromotionActions' }).attrs({
    mt: 1,
})``;

export const ButtonWrapper = styled(Flex)
    .withConfig({ displayName: 'ButtonWrapper' })
    .attrs((props) => ({
        ...props,
        direction: 'row',
        spacing: 1,
        flexWrap: 'wrap',
    }))``;
